import { useSelector } from 'react-redux';

import { profileSelector } from './selectors';

export function useGetProfile() {
  return useSelector(profileSelector);
}
